import type { CSSProperties } from "react";

/**
 * Clips a control to 1×1 instead of hiding it with `display: none` or the `hidden`
 * attribute: those drop the element out of the tab order and the accessibility tree,
 * so a keyboard-only user could never reach it. This keeps it focusable and announced
 * while something else stands in for it visually.
 */
export const VISUALLY_HIDDEN_STYLE: CSSProperties = {
  position: "absolute",
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0 0 0 0)",
  whiteSpace: "nowrap",
  border: 0,
};
